import React from "react"
import { Link } from "react-router-dom";
import { DIVISION_SECTION } from "../../../data/homepage/division_section/division_section";
import styles from './division_section.module.css';

const CONTENT = DIVISION_SECTION

const DivisionSection = () => {
    return(
        <>
            <section className={styles.section}>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h2>01</h2>
                            <h3>공공·기업·R&D 프로젝트</h3>
                            <p>{CONTENT.WEB.PROJECTS}</p>
                        </div>

                        <figure>
                            <img src="./images/division_section/smart_city.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h2>02</h2>
                            <h3>AI·앱·시스템 개발</h3>
                            <p>{CONTENT.WEB.DEVELOPMENT}</p>
                        </div>

                        <figure>
                            <img src="./images/division_section/healthcare.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h2>03</h2>
                            <h3>자체 서비스 개발</h3>
                            <p>{CONTENT.WEB.SERVICES}</p>
                            <Link className={styles.educationLink} to="/services">서비스 자세히 보기</Link>
                        </div>

                        <figure>
                            <img src="./images/division_section/smart_farm1.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h2>04</h2>
                            <h3>실무 개발 교육</h3>
                            <p>{CONTENT.WEB.EDUCATION}</p>
                            <Link className={styles.educationLink} to="/education">교육·강의 자세히 보기</Link>
                        </div>

                        <figure>
                            <img src="./images/division_section/data_platform3.jpg" alt="" />
                        </figure>
                    </div>
                </article>
            </section>
            <section className={styles.phone_section}>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h5>01 공공·기업·R&D 프로젝트</h5>
                            <h3>공공·기업 프로젝트와</h3>
                            <h3>R&D 기획·연구를 연결합니다</h3>
                        </div>

                        <figure>
                            <img src="./images/division_section/smart_city.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h5>02 AI·앱·시스템 개발</h5>
                            <h3>고객사의 아이디어를</h3>
                            <h3>앱과 서비스로 구현합니다</h3>
                        </div>

                        <figure>
                            <img src="./images/division_section/healthcare.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h5>03 자체 서비스 개발</h5>
                            <h3>주말농장 서비스 운영과</h3>
                            <h3>음성 인터페이스 기획·연구</h3>
                            <Link className={styles.educationLink} to="/services">서비스 자세히 보기</Link>
                        </div>

                        <figure>
                            <img src="./images/division_section/smart_farm1.jpg" alt="" />
                        </figure>
                    </div>
                </article>
                <article>
                    <div className={styles.inner}>
                        <div className={styles.txt}>
                            <h5>04 실무 개발 교육</h5>
                            <h3>현장의 개발 경험을</h3>
                            <h3>실무 개발 교육으로 나눕니다</h3>
                            <Link className={styles.educationLink} to="/education">교육·강의 자세히 보기</Link>
                        </div>

                        <figure>
                            <img src="./images/division_section/data_platform3.jpg" alt="" />
                        </figure>
                    </div>
                </article>
            </section>
        </>
    )
}

export default React.memo(DivisionSection);